// React
import { Fragment } from "react"

// Components
import { ApproveAction } from "./ApproveAction"

import {TableNumber } from "components"

// Third-Party Libraries
import moment from "moment"

import { APPROVAL, convertNumber } from "utils"

// context
import { PaginationState } from "types"
import { ApproveType } from "../types"

type TypeParams = {
    data: ApproveType
    index: number
    refetch: () => void
    pagination: PaginationState
}

export function Item({
    data,
    index,
    refetch,
    pagination, 
}: TypeParams) {
 
    return (
        <Fragment>
            <tr key={index}>
                <td>{TableNumber({ dataLength:pagination.limit , pageCurrent: pagination.page, index: index, limit: pagination.limit, totalData: pagination.total })}</td>
                <td>
                    <ApproveAction data={data} refetch={refetch} />
                </td>
                <td>{moment(data.transaction_date).format("DD/MM/YYYY")}</td>
                <td>{data.location_name}</td>
                <td>{data.product_barcode}</td>
                <td>{data.product_name}</td>
                <td className="text-center">{convertNumber(Number(data.soh)).intoNormalAmount}</td>
                <td>{data.unit_name}</td>
                <td>{APPROVAL[data.approve_status]}</td>
                <td>{data.approve_date ? moment(data.approve_date).format("DD/MM/YYYY") : ""}</td>
            </tr>
        </Fragment>
    )
}